var React = require('react');

function FacebookImpressionLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.3663 10.0001L6.57212 10.0001V20.0001L2.42077 20.0001V10.0001L0.464844 10.0001V6.48012L2.42077 6.48012V4.20012C2.42077 2.56012 3.21911 0.000122047 6.61204 0.000122019L9.68563 0.000121994V3.44012L7.45029 3.44012C7.32607 3.43287 7.20179 3.45343 7.08649 3.5003C6.97118 3.54717 6.86773 3.61918 6.78365 3.71109C6.69957 3.80301 6.63696 3.91253 6.60037 4.03171C6.56378 4.15089 6.55413 4.27674 6.57212 4.40012V6.48012L9.72555 6.48012L9.3663 10.0001Z","fill":"white"}));
}

FacebookImpressionLogo.defaultProps = {"width":"10","height":"20","viewBox":"0 0 10 20","fill":"none"};

module.exports = FacebookImpressionLogo;

FacebookImpressionLogo.default = FacebookImpressionLogo;
